"use strict";
/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.StatsPriceSquareFootResponse$ = exports.StatsPriceSquareFootResponse$outboundSchema = exports.StatsPriceSquareFootResponse$inboundSchema = void 0;
exports.statsPriceSquareFootResponseToJSON = statsPriceSquareFootResponseToJSON;
exports.statsPriceSquareFootResponseFromJSON = statsPriceSquareFootResponseFromJSON;
const z = __importStar(require("zod"));
const schemas_js_1 = require("../../../lib/schemas.js");
const fastapikrakenendpointsstatsmodelssaleslocalauthoritygetpricepersquarefootresponsesstatspricepersquarefootwrapper_js_1 = require("./fastapikrakenendpointsstatsmodelssaleslocalauthoritygetpricepersquarefootresponsesstatspricepersquarefootwrapper.js");
/** @internal */
exports.StatsPriceSquareFootResponse$inboundSchema = z.object({
    data: fastapikrakenendpointsstatsmodelssaleslocalauthoritygetpricepersquarefootresponsesstatspricepersquarefootwrapper_js_1.FastapiKrakenEndpointsStatsModelsSalesLocalAuthorityGetPricePerSquareFootResponsesStatsPricePerSquareFootWrapper$inboundSchema,
});
/** @internal */
exports.StatsPriceSquareFootResponse$outboundSchema = z.object({
    data: fastapikrakenendpointsstatsmodelssaleslocalauthoritygetpricepersquarefootresponsesstatspricepersquarefootwrapper_js_1.FastapiKrakenEndpointsStatsModelsSalesLocalAuthorityGetPricePerSquareFootResponsesStatsPricePerSquareFootWrapper$outboundSchema,
});
/**
 * @internal
 * @deprecated This namespace will be removed in future versions. Use schemas and types that are exported directly from this module.
 */
var StatsPriceSquareFootResponse$;
(function (StatsPriceSquareFootResponse$) {
    /** @deprecated use `StatsPriceSquareFootResponse$inboundSchema` instead. */
    StatsPriceSquareFootResponse$.inboundSchema = exports.StatsPriceSquareFootResponse$inboundSchema;
    /** @deprecated use `StatsPriceSquareFootResponse$outboundSchema` instead. */
    StatsPriceSquareFootResponse$.outboundSchema = exports.StatsPriceSquareFootResponse$outboundSchema;
})(StatsPriceSquareFootResponse$ || (exports.StatsPriceSquareFootResponse$ = StatsPriceSquareFootResponse$ = {}));
function statsPriceSquareFootResponseToJSON(statsPriceSquareFootResponse) {
    return JSON.stringify(exports.StatsPriceSquareFootResponse$outboundSchema.parse(statsPriceSquareFootResponse));
}
function statsPriceSquareFootResponseFromJSON(jsonString) {
    return (0, schemas_js_1.safeParse)(jsonString, (x) => exports.StatsPriceSquareFootResponse$inboundSchema.parse(JSON.parse(x)), `Failed to parse 'StatsPriceSquareFootResponse' from JSON`);
}
//# sourceMappingURL=statspricesquarefootresponse.js.map